'use client';

var getBannerImageResponsive = function (langCode) {
    if (langCode === void 0) { langCode = 'vi'; }
    return "https://images.vietnamworks.com/images/view-applied-candidates/responsive-competitive-".concat(langCode, ".png");
};
var VNW_APPLIED_CANDIDATE = 'VNW_APPLIED_CANDIDATE';

export { VNW_APPLIED_CANDIDATE, getBannerImageResponsive };
//# sourceMappingURL=constants.js.map
